import React from 'react';

import './dash-content-footer.scss';
import { default as t } from '../../../utils/i18n';
// import config from '../../../utils/config';
import { ReactComponent as PublicisMediaLogo } from '../../../assets/svg/logo_publicismedia.svg';

const DashContentFooter = ({ viewedRecords=6, totalRecords=12}) => {
  return (
    <footer className="c-business--footerContent">
        {/* <section className="c-business--footer-logo">
            
        </section> */}
        <section className="c-business--label .c-text-heading-4 footer-right-col">
            <p className="c-text-heading-4 copyright">{t('dashboard.footer.copyrightText')}</p> 
            <PublicisMediaLogo className="c-footer-logo" /> 
        </section>
    </footer>
  );
}

export default DashContentFooter;
